// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { FacebookAuthProvider, GoogleAuthProvider, getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcKcS6h-0stDEUnqq9YXM9KPA1UFtdRL4",
  authDomain: "topband-406808.firebaseapp.com",
  projectId: "topband-406808",
  storageBucket: "topband-406808.appspot.com",
  messagingSenderId: "654348471298",
  appId: "1:654348471298:web:53ff267ce49e5cd78fab1b",
  measurementId: "G-6L67GVL2KD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth =  getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const fbProvider = new FacebookAuthProvider();
export const db = getFirestore(app);
